import React, { Component } from 'react';
// import { Consumer, MyContext } from '../../../context/Context'
import { FilePond, registerPlugin, File } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
// import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
// import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
// import FilePondPluginImageResize from 'filepond-plugin-image-resize';
// import FilePondPluginImageCrop from 'filepond-plugin-image-crop';

// import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
// import "filepond/dist/filepond.min.css"

import moment from 'moment'
import {  Message } from 'semantic-ui-react'


// import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
// import "filepond/dist/filepond.min.css";
// import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
// import { Consumer, MyContext } from '../../../context/Context';
// import firebase from 'firebase'

import { MyStore } from '../../../services/Store'

import toaster from "toasted-notes";
import "toasted-notes/src/styles.css"; // optional styles





// Register the plugins
// const image2base64 = require('image-to-base64');
const uuid = require('uuid/v4');
// const filesGroupId = uuid()
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);
// registerPlugin(FilePondPluginFileEncode);
// registerPlugin(FilePondPluginImageTransform);
// registerPlugin(FilePondPluginImageResize);
// registerPlugin(FilePondPluginImageCrop)


// const FilesContext = React.createContext();

// const reducer = (state, action) => {

//   switch (action.type) {

//     default:
//       return state;
//   }
// }


// export class Provider extends Component {

//   constructor(props) {
//     super(props)
//     this.kcount = 0
//     // this.printStates()
//     // this.authStateListner()
//     this.database = MyStore.database().ref();
//     this.localId = ''
//     this.state = {
//       localId: '',
//       // filesGroupId,
//       myFiles: [],
//       logs: [],
//       kcount: 0,
//       dispatch_files: action => {
//         this.setState(state => reducer(state, action))
//       }
//     }


//   }

//   componentDidMount() {

//     this.token = localStorage.getItem('token');
//     this.localId = localStorage.getItem('userId');
//     this.setState({ user: this.localId });
//     if (!this.token) {
//       this.context.dispatch({
//         type: 'AUTH_LOGOUT',
//         payload: { token: null, localId: null }
//       });
//     } else {
//       this.expDate = new Date(localStorage.getItem('expDate'));
//       if (this.expDate < new Date()) {
//         this.context.dispatch({
//           type: 'AUTH_LOGOUT',
//           payload: { token: null, localId: null }
//         });
//       } else {

//         this.context.dispatch({
//           type: 'AUTH_LOGIN',
//           payload: { token: this.token, localId: this.localId }
//         });
//       }
//     }
//     // console.log(this.token)
//     // console.log(this.localId)
//     // console.log(this.expDate)
//   }

//   componentDidUpdate = () => {
//     console.log('----------- comp update ---------- ')

//   }


//   printStates = () => {
//     console.log('----------- print States ------------')
//     return (
//       <FilesContext.Provider value={this.state}>
//         {this.props}
//       </FilesContext.Provider>

//     )
//   }





//   uthStateListner = () => {

//   }

//   render() {
//     return (

//       <FilesContext.Provider value={this.state}>
//         {this.props.children}
//       </FilesContext.Provider>


//     )
//   }

// }


// displayName: "ykimapi"
// photoURL: "http://gravatar.com/avatar/f24e4786179b253a30b68e8e1b03f63c?d=identicon"
// email: "yosepkimapi@gmail.com"

class FileImage extends Component {
  constructor(props) {
    super(props);
    this.storageRef = MyStore.storage().ref();
    this.databaseRef = MyStore.database().ref();
    this.currentUser = MyStore.auth().currentUser.displayName
    this.token = undefined
    this.expDate = undefined
    this.localId = undefined
    this.metaFiles = []
    this.filesGroupId = this.props.filesGroupId
    this.log = []
    this.kcount = 0
    // this.provider = new Provider()
    // this.projectImages = undefined

  }
  state = {
    files: [], // is used to store file upload information
    // uploadValue: 0, // Used to view the process. Upload
    filesMetadata: [], // Used to receive metadata from Firebase.
    // rows: [], // draw the DataTable
    // message: '',
    myFiles: [],
    logs: [],
    //   dispatch:action=>{
    //     this.setState(state=>reducer(state,action))
    // }
    // key: uuid(),
  }


  componentDidMount() {
    // console.log(this.props)
    this.token = this.props.auth.token
    // console.log(this.currentUser)
    // this.token = this.props.auth.token
    // if (!this.token) {
    //   this.context.dispatch({
    //     type: 'AUTH_LOGOUT',
    //     payload: { token: null, localId: null }
    //   });
    // } else {
    //   this.expDate = this.props.auth.expDate
    //   if (this.expDate < new Date()) {
    //     this.context.dispatch({
    //       type: 'AUTH_LOGOUT',
    //       payload: { token: null, localId: null }
    //     });
    //   } else {
    //     this.localId = this.props.auth.localId
    //     this.context.dispatch({
    //       type: 'AUTH_LOGIN',
    //       payload: { token: this.token, localId: this.localId }
    //     });
    //   }
    // }
    // console.log(this.token)
    // console.log(this.localId)
    // console.log(this.expDate)
  //   console.log('------------props fireshare.js ------')
  //   console.log(this.props)
  }

  componentDidUpdate() {

    // console.log('------------props fireshare.js ------')
    // console.log(this.props)


  }
  

  //groups/oid/cards
//:groupId/:filegroupid/    * storage
// this.storageRef.child('groups').child(this.props.oid).child(this.props.filesGroupId).child(name).delete().then(()=>{

//groups/:oid/files
// a = databaseRef.child(groups).child(this.props.oid).child('files').child(this.props.filesGroupId).on('value', snap => {})

//groups/:oid/logs
// a = databaseRef.child(groups).child(this.props.oid).child('logs').child(this.props.filesGroupId).on('value', snap => {})





  handleProcessing(fieldName, file, metadata, load, error, progress, abort) {

    if (localStorage.getItem('userId') === undefined || localStorage.getItem('userId')  === null){
      toaster.notify(<div>
              
        <Message info color='red' style={{width:"120px"}} >
          <Message.Header>Please Login to Upload an Image</Message.Header>
          {/* <p>Did you know it's been a while?</p> */}
        </Message></div>)
      
       return 
     }
  

    const fileUpload = file;

    const task = this.storageRef.child('groups').child(this.props.oid).child(this.props.filesGroupId).child(file.name).put(fileUpload)


    // const task = this.storageRef.child(this.localId).child(this.props.filesGroupId).child(file.name).put(fileUpload)

    task.on(`state_changed`, (snapshot) => {
      console.log(snapshot.bytesTransferred, snapshot.totalBytes)
      let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      progress(true, snapshot.bytesTransferred, snapshot.totalBytes);

    }, (error) => {
      this.setState({
        messag: `Upload error : ${error.message}`
      })
    }, () => {
      //Success
      this.setState({
        messag: `Upload Success`,
        picture: task.snapshot.downloadURL
      })
      setTimeout(() => {
        load(Date.now())
      }, 1000);
      this.storageRef.child('groups').child(this.props.oid).child(this.props.filesGroupId).child(file.name).getMetadata().then((metadata) => {
    //   this.storageRef.child(this.localId).child(this.props.filesGroupId).child(file.name).getMetadata().then((metadata) => {
        let downloadURL = ''
        this.storageRef.child('groups').child(this.props.oid).child(this.props.filesGroupId).child(file.name).getDownloadURL().then(url => {

        // this.storageRef.child(this.localId).child(this.props.filesGroupId).child(file.name).getDownloadURL().then(url => {

          let metadataFile = {
            name: metadata.name,
            size: metadata.size,
            contentType: metadata.contentType,
            fullPath: metadata.fullPath,
            downloadURL: url,
            source: metadata.fullPath,
            id: uuid(),
            filesGroupId: this.props.filesGroupId,

          }

          const id = this.props.uid
          let fileId = uuid()
   

          const filesRef = this.databaseRef.child('groups').child(this.props.oid + '/files/' + this.props.filesGroupId).child(fileId)
          const logsRef = this.databaseRef.child('groups').child(this.props.oid + '/logs/' + this.props.filesGroupId)
          

        //   const filesRef = this.databaseRef.child('/groups/'+this.props.oid + '/files/' + this.props.filesGroupId).child(fileId)
        //   const logsRef = this.databaseRef.child('/groups/'+this.props.oid + '/logs/' + this.props.filesGroupId)

        //   const filesRef = this.databaseRef.child(this.localId + '/files/' + this.props.filesGroupId).child(fileId)
        //   const logsRef = this.databaseRef.child(this.localId + '/logs/' + this.props.filesGroupId)

          metadataFile.key = fileId
          filesRef.set({ metadataFile })
          this.metaFiles.push(metadataFile)


          logsRef.push().set({
            displayName: this.currentUser,
            id: uuid(),
            action: `${file.name} uploaded`,
            timestamp: Date.now(),
            momentTimestamp: moment().format('LLL')
          });


          // this.provider.state.myFiles = this.metaFiles



          // console.log('------- kcount ----------')
          // console.log(this.kcount)
          // this.kcount +=1

          // console.log('--------- Provider -------------')
          // console.log(this.provider.kcount)
          // this.provider.kcount +=1
          // this.provider.printStates()

          // this.provider.authStateListner()

          // this.provider.setState({myFiles: this.metaFiles});

          toaster.notify(<div>
            
            <Message info color='teal' style={{width:"120px"}} >
            {/* <Label  color='teal' ribbon='right'>Draft</Label> */}
              <Message.Header>Uploaded Successfully</Message.Header>
              {/* <p>Did you know it's been a while?</p> */}
            </Message></div>)


        })

      }).catch(function (error) {
        console.log(error)
      });
    })
  }
  handleInit() {
    console.log("FilePond instance has initialised", this.pond);
  }



//   <Segment placeholder>
//   <Header icon>
//     <Icon name='images' />
//     No documents are listed for this customer.
//   </Header>
//   <Button primary>Add Document</Button>
// </Segment>

  render() {
    return (
      <div className="fileshare">
        <FilePond
          ref={ref => (this.pond = ref)}
          files={this.state.files}
          allowMultiple={true}
          allowDrop
          allowBrowse
          acceptedFileTypes={['image/jpeg', 'image/png']}
          // labelIdle = '<span > Wait until completion one image per Upload</span>'
          // labelIdle='
          // <div class="ui icon header">
          // <i aria-hidden="true" class="images icon"></i>
          // Drag & Drop or <u color="teal"><a>Browse</a></u>
          // </div>'
         
          allowRevert={false}
          instantUpload={false}
          server={{
            process: this.handleProcessing.bind(this),
          }}
          oninit={() => this.handleInit()}
          onupdatefiles={fileItems => {
            this.setState({
              files: fileItems.map(fileItem => fileItem.file)
            });
          }}>

        </FilePond>

        <br></br><br></br>
        <br></br><br></br>

      </div>
    )
  }
}
// FileImage.contextType = MyContext;
// Provider.contextType = MyContext;
// export const FilesConsumer = FilesContext.Consumer;
export default FileImage;


// const divStyle = {
// '[data-filepond-item-state='processing-complete'] .filepond--item-panel { background: green !important; }';

// };

// const divstyles = (
//   '[data-filepond-item-state="processing-complete"] .filepond--item-panel { background: green !important; }'

// )

// var style = document.createElement('style');
// style.type = 'text/css';
// style.innerHTML = '.filepond--file { color: #F00 !important; }';
// style.innerHTML = '[data-filepond-item-state='processing-complete'] .filepond--item-panel { background: green !important; }';
// document.getElementsByTagName('head')[0].appendChild(style);
